var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChainPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 522,
    viewBox: "0 0 1920 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.35,
    d: "M1290.3 362.378C1288.44 360.717 1323.02 324.157 1367.52 280.702C1412.02 237.247 1449.62 203.354 1451.48 205.014C1453.34 206.675 1418.78 243.261 1374.25 286.716C1329.73 330.171 1292.16 364.039 1290.3 362.378Z",
    fill: "url(#paint0_radial_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.35,
    d: "M1607.26 345.897C1607.26 344.74 1641.25 346.853 1682.92 350.653C1724.59 354.452 1758.39 358.503 1758.17 359.661C1757.96 360.818 1724.16 358.705 1682.49 354.905C1640.82 351.106 1607.13 347.08 1607.26 345.897Z",
    fill: "url(#paint1_radial_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.35,
    d: "M116.062 16.9276C116.547 16.4244 135.792 32.0248 159.187 51.7267C182.582 71.4286 200.883 87.8344 200.398 88.3377C199.913 88.8409 180.642 73.2404 157.408 53.5636C134.175 33.8869 115.631 17.4309 116.062 16.9276Z",
    fill: "url(#paint2_radial_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.35,
    d: "M951.334 45.7633C951.523 44.7065 990.282 49.9403 1037.91 57.4638C1085.53 64.9872 1123.94 71.9571 1123.75 73.0139C1123.56 74.0707 1084.81 68.7867 1037.21 61.2381C989.608 53.6894 951.173 46.8201 951.334 45.7633Z",
    fill: "url(#paint3_radial_5037_18652)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.99
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.764 142.134L199.534 87.5828L231.312 185.841L125.764 142.134Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.88
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.764 142.134L161.827 199.177L231.312 185.841L267.456 118.105L237.053 129.453L231.312 185.841",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.39
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5059 42.4169L111.614 13.9082L199.535 87.5828L52.5059 42.4169Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.53
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5059 100.541V42.4167L199.535 87.5827L52.5059 100.541Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5191 1L52.5059 42.4168L111.614 13.9082L57.5191 1Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M267.457 118.105L283.44 81.0157L311.364 112.166L267.457 118.105Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.37
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M311.359 112.166L369.308 197.516L314.055 223.534L311.359 112.166Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.39
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M346.753 252.873L350.903 264.145L327.858 285.382C327.784 285.444 327.688 285.48 327.589 285.484C327.489 285.487 327.391 285.458 327.311 285.402C327.231 285.345 327.175 285.265 327.152 285.174C327.129 285.083 327.141 284.988 327.185 284.904L346.753 252.873Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.32
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M505.503 89.6964L500.221 166.617L565.393 147.343L505.503 89.6964Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.61
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.805 264.447L186.299 233.825L166.246 281.608L218.805 264.447Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.63
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M235.246 16.2732L240.529 59.0236L272.792 32.6286L235.246 16.2732Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M849.021 17.4813L852.067 42.0899L870.665 26.892L849.021 17.4813Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.48
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9533 160.528L0 215.23L83.3658 235.435L85.9533 160.528Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.53
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1784.02 5.02583L1787.93 37.5101L1811.11 17.5314L1784.02 5.02583Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.65
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1087.42 343.708L1094.56 403.317L1137.1 366.63L1087.42 343.708Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M739.672 89.6965L767.514 169.36L871.472 79.6819L739.672 89.6965Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.74
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1781.52 228.113L1866.85 225.396L1861.03 147.343L1781.52 228.113Z",
    stroke: "white",
    strokeWidth: 0.48,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.96
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M378.42 46.4177L395.535 126.71L311.361 112.166L378.42 46.4177ZM378.42 46.4177L283.438 81.0156",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M378.419 48.4808L473.671 42.4167L395.534 126.71L369.309 197.516L436.071 198.346L395.534 126.71",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M436.071 198.346L381.815 258.786L369.309 197.516",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.22
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M500.221 166.617L577.657 216.388L565.393 147.343L702.773 160.477L577.657 216.388",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.83
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M702.772 160.477L735.089 223.534L577.656 216.388",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.77
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M735.089 223.533L719.16 251.237L757.11 262.434L735.089 223.533Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.29
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M757.11 262.434L741.908 359.912L851.984 308.003L909.098 342.978L741.908 359.912L812.04 481.546L909.098 342.978",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.42
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M909.1 342.978L1082.6 278.89L1032.54 422.817L909.1 342.978Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.44
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M909.1 342.978L951.362 233.825L851.986 308.003",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M735.09 223.559L846.514 169.813L757.11 262.535L851.985 308.129L846.595 169.913L951.442 233.926L1082.68 279.016L1064.38 174.644M1064.38 174.644C1064.38 174.644 954.622 228.642 951.307 233.825L933.518 43.8007L1064.38 174.644Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.71
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M846.514 169.813L933.572 43.8007L1133.29 76.7883L1064.43 174.619L1206.66 181.211L1133.29 76.7883",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1082.6 278.89L1206.66 181.211L1264.66 386.181L1082.6 278.89Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1265.69 386.182L1469.64 188.86L1207.68 181.211L1402.55 68.1075L1469.64 188.86",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.36
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1708.5 55.174L1786.5 61.1626L1772.24 130.56L1708.5 55.174Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.76
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1871.03 21.7084L1920 99.5599L1846.96 105.045L1741.38 193.54L1772.24 130.56L1846.96 105.045L1786.5 61.1625L1871.03 21.7084ZM1871.03 21.7084L1846.96 105.045",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.53 494.177L1680.87 521L1538.97 343.331L1610.07 81.4182L1468.59 188.86L1538.97 343.331L1264.66 386.182L1393.53 494.177ZM1393.53 494.177L1538.97 343.331L1741.38 193.541L1610.07 81.4182L1401.53 68.1074",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.48
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1680.87 521C1680.87 521 1810.87 373.903 1804.08 366.706C1797.28 359.51 1538.96 343.331 1538.96 343.331",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.92
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M741.908 359.912L719.16 251.237L558.277 414.438L741.908 359.912Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M311.363 112.166L267.457 118.105L231.312 184.08L311.363 112.166Z",
    fill: "url(#paint4_linear_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M378.232 46.5936L395.536 126.71L473.673 42.4167L378.232 46.5936Z",
    fill: "url(#paint5_linear_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M100.534 128.169L21.373 178.67L37.7335 133.328L100.534 128.169Z",
    fill: "url(#paint6_linear_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M758.512 262.434L847.915 169.812L853.386 308.003L758.512 262.434Z",
    fill: "url(#paint7_linear_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1064.38 174.644C1068.71 174.644 1133.24 76.7883 1133.24 76.7883L1206.58 181.211L1064.38 174.644Z",
    fill: "url(#paint8_linear_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1152.62 427.473L1216.5 377.123L1241.94 468.109L1152.62 427.473Z",
    fill: "url(#paint9_linear_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1611.12 82.9027C1614.7 82.173 1772.24 130.56 1772.24 130.56L1741.38 193.465L1611.12 82.9027Z",
    fill: "url(#paint10_linear_5037_18652)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1717.66 37.5352C1720.98 30.4395 1747.5 13.3795 1747.5 13.3795L1754.13 37.5352H1717.66Z",
    fill: "url(#paint11_linear_5037_18652)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5037_18652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1387.22 253.303) rotate(136.139) scale(99.009 4.15676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D6EBFE",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B3DBFC",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A5D4FC",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8BB5FB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#6C8DFA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#5571F9",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#4760F8",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#425AF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5037_18652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1374.3 528.248) rotate(-174.078) scale(66.5277 1.62555)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D6EBFE",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B3DBFC",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A5D4FC",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8BB5FB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#6C8DFA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#5571F9",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#4760F8",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#425AF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5037_18652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-13.4014 -167.564) rotate(-139.518) scale(48.2958 1.235)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D6EBFE",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B3DBFC",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A5D4FC",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8BB5FB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#6C8DFA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#5571F9",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#4760F8",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#425AF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5037_18652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(655.453 -383.964) rotate(-170.432) scale(76.6534 2.1879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D6EBFE",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#B3DBFC",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A5D4FC",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8BB5FB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#6C8DFA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#5571F9",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#4760F8",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#425AF8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5037_18652",
    x1: 211.745,
    y1: 199.378,
    x2: 287.184,
    y2: 105.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5037_18652",
    x1: 378.232,
    y1: 84.5633,
    x2: 473.673,
    y2: 84.5633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5037_18652",
    x1: 102.2,
    y1: 131.973,
    x2: 16.305,
    y2: 165.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5037_18652",
    x1: 849.91,
    y1: 127.867,
    x2: 811.376,
    y2: 286.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5037_18652",
    x1: 1171.14,
    y1: 50.4939,
    x2: 1138.85,
    y2: 183.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5037_18652",
    x1: 1223.86,
    y1: 352.615,
    x2: 1199.98,
    y2: 450.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5037_18652",
    x1: 1699.23,
    y1: 79.6568,
    x2: 1676.96,
    y2: 171.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5037_18652",
    x1: 1745.51,
    y1: 3.16368,
    x2: 1736.65,
    y2: 39.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainPattern);
export default __webpack_public_path__ + "static/media/chain_pattern.2ef334214ba2450c302fe2e2c9d66d88.svg";
export { ForwardRef as ReactComponent };